import { usePcsClient } from 'src/context/pcs-auth-context';

type EventMilestoneData = {
  metricName: string;
  eventId: string;
  payload?: {
    [key: string]: string | number;
  };
};

type AgentMilestoneData = {
  metricName: string;
  agentId: string;
  payload?: {
    [key: string]: string | number;
  };
};

export const useEventMilestone = () => {
  const client = usePcsClient();
  const sendEventMilestone = async ({
    metricName,
    eventId,
    payload,
  }: EventMilestoneData) => {
    const eventPayload = {
      metricName,
      eventId: Number.parseInt(eventId),
      source: 'agent_portal',
      payload,
      timestamp: new Date().toISOString(),
    };
    if (payload?.agent_id != null && typeof payload.agent_id !== 'number') {
      eventPayload.payload.agent_id = Number.parseInt(payload.agent_id);
    }
    if (
      payload?.location_id != null &&
      typeof payload.location_id !== 'number'
    ) {
      eventPayload.payload.location_id = Number.parseInt(payload.location_id);
    }

    client('metrics/events', {
      method: 'POST',
      keepalive: true,
      data: eventPayload,
    });
  };

  return sendEventMilestone;
};

export const useAgentMilestone = () => {
  const client = usePcsClient();
  const sendAgentMilestone = async ({
    metricName,
    agentId,
    payload,
  }: AgentMilestoneData) => {
    const agentPayload = {
      metricName,
      agentId: Number.parseInt(agentId),
      source: 'agent_portal',
      payload,
      timestamp: new Date().toISOString(),
    };

    client('metrics/agents', {
      method: 'POST',
      keepalive: true,
      data: agentPayload,
    });
  };

  return sendAgentMilestone;
};
